import { useContext } from 'react';
import classNames from 'classnames';
import { Check } from '@styled-icons/boxicons-regular';
import Image from 'next/legacy/image';
import { TEMPLATE_TYPE } from '@typedream/data';
import { SaveTemplatePopupContext } from '../contextProvider';

function Success() {
  const {
    templateType,
  } = useContext(SaveTemplatePopupContext);

  return (
    <div>
      <Check size={70} className="with-accent-text-color mb-5" />
      <div className={classNames('is-size-4 with-text-color mb-5')}>
        Template Saved!
      </div>
      <div className={classNames('is-subtitle mb-4')}>
        You and collaborators of this site can now use this template
        within this site. Simply go to a new page and click on
        {' '}
        <strong className="with-text-color">{templateType === TEMPLATE_TYPE.FORM ? 'create new form' : 'start with a template'}</strong>
      </div>
      <Image
        src={templateType === TEMPLATE_TYPE.FORM ? '/images/create_new_form.png' : '/images/start_with_template.png'}
        width={350}
        height={189}
        objectFit="contain"
      />
    </div>
  );
}

export default Success;
